/**
 * Renders an esg answer component for the given answer esg-item
 * @param {EsgItem} esgItem
 * @returns {string}
 * @constructor
 */
function EsgAnswerComponent(esgItem) {
  return `
      <li class='flex items-center justify-between py-3 pl-3 pr-4 text-sm'>
          <div class='px-6 py-4 overflow-hidden bg-white shadow sm:rounded-lg my-4 esg-item' id='${
            esgItem.item.id
          }-item-details' data-type='${esgItem.item.type}'>
            <div class='px-4 py-5 sm:px-6'>
              <h3 class='text-lg font-medium leading-6 text-gray-900'>${esgItem.item.title}</h3>
              ${
                esgItem.item.hint
                  ? `
                  <p class='mt-1 max-w-2xl text-sm text-gray-500'>${esgItem.item.hint}</p>
              `
                  : ''
              }
            </div>
            <div class='border-t border-gray-200 px-4 py-5 sm:p-0'>
              <dl class='sm:divide-y sm:divide-gray-200'>
  
                  ${Object.keys(esgItem.item)
                    .map(
                      (property) => `
                    <div class='py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:py-5 sm:px-6'>
                      <dt class='text-sm font-medium text-gray-500'>item.${property}</dt>
                      <dd class='mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0'>${esgItem.item[property]}</dd>
                    </div>
                  `
                    )
                    .join('')}
                <div class='py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:py-5 sm:px-6'>
                  <dt class='text-sm font-medium text-gray-500'>parent</dt>
                  <dd class='mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0'>
                      ${
                        esgItem.parent
                          ? `
                          <a href='#${esgItem.parent}-item' class='font-medium text-indigo-600 hover:text-indigo-500'>${esgItem.parent}</a>
                      `
                          : 'null'
                      }
                  </dd>
                </div>
              </dl>
            </div>
          </div>
      </li>
    `;
}

export default EsgAnswerComponent;
